import React, {useCallback, useContext, useEffect, useState, useRef} from 'react';
import {
    View,
    Text,
    Dimensions,
    StyleSheet,
    TouchableOpacity,
    Alert,
    ScrollView,
    FlatList,
    Platform, Modal
} from 'react-native';
import TimeAgo from "react-native-timeago";
import {priceFormatter, calcDeliveryFee} from "../helpers";
import axios from "axios";
import {ApiConfig} from "../config/ApiConfig";
import {getAccessToken} from "../helpers/storage";
import OrderAcceptTimePicker from "../components/OrderAcceptTimePicker";
import OrderRejectModal from "../components/OrderRejectModal";
import {LinearGradient} from "expo-linear-gradient";
import { HappyDialog } from '../helpers/crossPlatformTools/dialogs';
import Observables from "@happy-gastro/global-observables";
import { Animated } from 'react-native';
import {CurrentScreenContext} from "../helpers/CurrentScreenContext";
import {calcVatPercentages} from "../constants/converter";

// TODO: We can create a more accurate event title based on the event type and details
import { useTranslation } from 'react-i18next';
import {useFocusEffect} from "@react-navigation/native";
import {OrdersContext} from "../helpers/OrdersContext";
import {RawBTPrintKitchen, RawBTPrintTicket} from "../helpers/rawBTDriver";
import PairingModal from "../components/PairingModal";
import {FontAwesome5, Ionicons, MaterialIcons} from "@expo/vector-icons";
import AsyncStorage from "@react-native-async-storage/async-storage";
import DeliveryModal from "../components/DeliveryModal";
import {WebView} from "react-native-webview";
import Toast from "react-native-toast-message";

const eventTitle = (title, t) => {
    switch (title) {
        case 'created': return t('created');
        case 'itemsAdded': return t('items_added');
        case 'update': return t('update');
        case 'statusUpdate': return t('status_update');
        default: return t('update');
    }
}

const orderType = (type, t) => {
    switch (type) {
        case 'takeAway': return t('take_away');
        case 'dineIn': return t('dine_in');
        case 'online': return t('online');
        default: return t('take_away');
    }
}

const paymentType = (type, t) => {
    switch (type) {
        case 'temporary': return t('temporary');
        case 'cash': return t('cash');
        case 'creditCard': return t('credit_card');
        case 'szepCard': return t('szep_card');
        case 'szepCreditCard': return t('szep_card');
        case 'voucher': return t('vouchers');
        case 'employeeBalance': return t('employee_balance');
        default: return t('temporary');
    }
}

const Timeline = ({ orderData }) => {
    //todo: test with orders not from our system, orders that have history instead of events
    const { t } = useTranslation();
    const events = [
        ...orderData?.events?.map(event => ({
            date: new Date(event.time).toISOString(),
            title: event.event,
            details: event.details,
            user: event.user ? event.user : false
        }))
    ];

    return (
        <ScrollView contentContainerStyle={{ paddingBottom: 70 }}>
            <Text style={styles.title}>{t('timeline')}</Text>
            <View style={styles.timeline}>
                {events.map((event, index) => (
                    <View key={index + "timeline!" } style={styles.eventRow}>
                        <View style={styles.iconContainer}>
                            <View style={styles.icon} />
                            {index < events.length - 1 && <View style={styles.verticalLine} />}
                        </View>
                        <View style={styles.eventCard}>
                            <Text style={styles.date}><TimeAgo time={new Date(event.date)} /></Text>
                            <Text style={styles.eventTitle}>{eventTitle(event.title, t)}</Text>
                            {/*{event.user && <Text style={styles.eventDescription}>{event.user}</Text>}*/}
                        </View>
                    </View>
                ))}
            </View>
        </ScrollView>
    );
};

const ReprintModal = ({ isVisible, onClose, orderData }) => {
    const { t } = useTranslation();
    const [showConfirmation, setShowConfirmation] = useState(false);

    const handlePress = (type) => {
        if(type === "invoice") {
            RawBTPrintTicket(orderData, orderData.items);
            onClose();
        }
        if(type === "kitchen_receipt") {
            RawBTPrintKitchen(orderData, orderData.items);
            onClose();
        }
        if(type === "cash_register") {
            // Show confirmation dialog
            setShowConfirmation(true);
        }
        if(type === "copy") {
            // Import the triggerPrintCashRegister function
            const { triggerPrintCashRegister } = require('../helpers/BackgroundTasks');

            // Use the background task to print cash register receipt
            triggerPrintCashRegister(orderData)
                .then(() => {
                    console.log('Cash register receipt printed successfully');
                })
                .catch(error => {
                    console.error('Failed to print cash register receipt:', error);
                });

            onClose();
        }
    };

    const handleConfirm = () => {
        // Import the triggerPrintCashRegister function
        const { triggerPrintCashRegister } = require('../helpers/BackgroundTasks');

        // Use the background task to print cash register receipt
        triggerPrintCashRegister(orderData)
            .then(() => {
                console.log('Cash register receipt printed successfully');
            })
            .catch(error => {
                console.error('Failed to print cash register receipt:', error);
            });

        setShowConfirmation(false);
        onClose();
    };

    const handleCancel = () => {
        setShowConfirmation(false);
    };

    return (
        <Modal
            transparent={true}
            visible={isVisible}
            animationType="slide"
            onRequestClose={onClose}
        >
            <TouchableOpacity style={styles.modalBackgroundReprint} onPress={onClose}>
                <View style={styles.modalContainerReprint}>
                    <TouchableOpacity style={styles.buttonReprint} onPress={() => handlePress("invoice")}>
                        <Text style={styles.buttonTextReprint}>{t('invoice')}</Text>
                    </TouchableOpacity>
                    <TouchableOpacity style={styles.buttonReprint} onPress={() => handlePress("kitchen_receipt")}>
                        <Text style={styles.buttonTextReprint}>{t('kitchen_receipt')}</Text>
                    </TouchableOpacity>

                    {/* New buttons with black background and white text */}
                    <TouchableOpacity 
                        style={[styles.buttonReprint, { backgroundColor: '#000' }]} 
                        onPress={() => handlePress("cash_register")}
                    >
                        <Text style={[styles.buttonTextReprint, { color: '#fff' }]}>{t('reprint_cash_register_receipt')}</Text>
                    </TouchableOpacity>
                    <TouchableOpacity 
                        style={[styles.buttonReprint, { backgroundColor: '#000' }]} 
                        onPress={() => handlePress("copy")}
                    >
                        <Text style={[styles.buttonTextReprint, { color: '#fff' }]}>{t('print_copy')}</Text>
                    </TouchableOpacity>
                </View>
            </TouchableOpacity>

            {/* Confirmation Dialog */}
            <Modal
                transparent={true}
                visible={showConfirmation}
                animationType="fade"
                onRequestClose={handleCancel}
            >
                <View style={styles.confirmationModalBackground}>
                    <View style={styles.confirmationModalContainer}>
                        <Text style={styles.confirmationTitle}>{t('confirmation')}</Text>
                        <Text style={styles.confirmationText}>{t('confirm_reprint_cash_register')}</Text>
                        <View style={styles.confirmationButtonsContainer}>
                            <TouchableOpacity 
                                style={[styles.confirmationButton, { backgroundColor: '#ccc' }]} 
                                onPress={handleCancel}
                            >
                                <Text style={styles.confirmationButtonText}>{t('cancel')}</Text>
                            </TouchableOpacity>
                            <TouchableOpacity 
                                style={[styles.confirmationButton, { backgroundColor: '#000' }]} 
                                onPress={handleConfirm}
                            >
                                <Text style={[styles.confirmationButtonText, { color: '#fff' }]}>{t('confirm')}</Text>
                            </TouchableOpacity>
                        </View>
                    </View>
                </View>
            </Modal>
        </Modal>
    );
};

const getOrderIcon = (source) => {
    switch (source) {
        case 'terminal':
            return <MaterialIcons name="point-of-sale" size={24} color="#555" />;
        case 'phone':
            return <Ionicons name="call" size={24} color="black" />;
        case 'webshop':
            return <Ionicons name="earth-outline" size={24} color="#555" />;
        case 'wolt':
            return <MaterialIcons name="delivery-dining" size={24} color="#00C2E8" />;
        case 'netpincer':
            return <MaterialIcons name="delivery-dining" size={24} color="#FF6900" />;
        default:
            return <MaterialIcons name="point-of-sale" size={24} color="#555" />;
    }
};

const getOrderTypeIcon = (type) => {
    switch (type) {
        case 'takeAway':
            return <MaterialIcons name="takeout-dining" size={20} color="#555" />;
        case 'dineIn':
            return <MaterialIcons name="restaurant" size={20} color="#555" />;
        case 'online':
            return <MaterialIcons name="devices" size={20} color="#555" />;
        default:
            return <MaterialIcons name="takeout-dining" size={20} color="#555" />;
    }
};

const getStatusIcon = (status) => {
    switch (status) {
        case 'accepted':
            return <MaterialIcons name="check-circle" size={20} color="#4CAF50" />;
        case 'preparing':
            return <MaterialIcons name="hourglass-top" size={20} color="#FF9800" />;
        case 'cancelled':
            return <MaterialIcons name="cancel" size={20} color="#F44336" />;
        case 'closed':
            return <MaterialIcons name="done-all" size={20} color="#2196F3" />;
        case 'busy':
            return <MaterialIcons name="access-time" size={20} color="#FFC107" />;
        case 'ready':
            return <MaterialIcons name="check-circle-outline" size={20} color="#4CAF50" />;
        case 'storno':
            return <MaterialIcons name="cancel" size={20} color="#F44336" />;
        default:
            return <MaterialIcons name="help-outline" size={20} color="#9E9E9E" />;
    }
};

const getPaymentTypeIcon = (type) => {
    switch (type) {
        case 'temporary':
            return <MaterialIcons name="pending" size={20} color="#9E9E9E" />;
        case 'cash':
            return <MaterialIcons name="payments" size={20} color="#4CAF50" />;
        case 'creditCard':
            return <MaterialIcons name="credit-card" size={20} color="#2196F3" />;
        case 'szepCard':
        case 'szepCreditCard':
            return <MaterialIcons name="card-membership" size={20} color="#9C27B0" />;
        case 'voucher':
            return <MaterialIcons name="local-offer" size={20} color="#FF9800" />;
        case 'employeeBalance':
            return <MaterialIcons name="account-balance-wallet" size={20} color="#607D8B" />;
        default:
            return <MaterialIcons name="help-outline" size={20} color="#9E9E9E" />;
    }
};

const OrderDetailsScreen = (props) => {
    const {orders} = useContext(OrdersContext);
    const { route, navigation } = props;
    const { orderData: propOrder, orderId  } = route?.params || props;
    const [haveToPair, setHaveToPair] = useState(false);
    const [orderData, setOrderData] = useState(propOrder);
    const [isReprintModalVisible, setReprintModalVisible] = useState(false);
    const [isAcceptModalVisible, setAcceptModalVisible] = useState(false);
    const [isRejectModalVisible, setIsRejectModal] = useState(false);
    const [isDialogVisible, setIsDialogVisible] = useState({ visible: false });
    const scrollViewRef = useRef(null);
    const [restaurantPlace, setRestaurantPlace] = useState(null);
    const [isDeliveryModalVisible, setDeliveryModalVisible] = useState(false);
    const [deliveryData, setDeliveryData] = useState(null);
    const [isTrackingShown, setTrackingShown] = useState(false);
    const [showInvoiceDetails, setShowInvoiceDetails] = useState(false);

    const { width, height } = Dimensions.get('window');
    const { t } = useTranslation();

    //useEffect(()=>{console.log("order:", orderData)},[])

    const [isPairingModalVisible, setPairingModalVisible] = useState(false);
    const [pairingItem, setPairingItem] = useState(null);
    //const [orderId, setOrderId] = useState(null);
    const [showPairingAlert, setShowPairingAlert] = useState(false);
    const fadeAnim = useRef(new Animated.Value(0)).current;
    const { setCurrentScreen } = useContext(CurrentScreenContext);

    useEffect(() => {
        setCurrentScreen('OrderDetailsScreen');
        return () => setCurrentScreen(null);
    }, [setCurrentScreen]);

    const triggerPairingAlert = () => {
        setShowPairingAlert(true);
            if (scrollViewRef.current) {
                scrollViewRef.current.scrollTo({
                    y: 0,
                    animated: true,
                });
            }
        Animated.sequence([
            Animated.timing(fadeAnim, {
                toValue: 1,
                duration: 500,
                useNativeDriver: false,
            }),
            Animated.timing(fadeAnim, {
                toValue: 0,
                duration: 500,
                useNativeDriver: false,
            }),
        ]).start()
    };

    const handleAcceptButtonPress = () => {
        if (isAllItemPaired(orderData)) {
            setAcceptModalVisible(true);
            console.log("all paired");
        } else {
            console.log("not all paired");
            triggerPairingAlert();
        }
    };

    // Function to open the PairingModal
    const openPairingModal = (item) => {
        setPairingItem(item);
        setPairingModalVisible(true);
    };

    // Function to close the PairingModal
    const closePairingModal = () => {
        setPairingModalVisible(false);
        setPairingItem(null);
    };

    useEffect(() => {
        const data = orders?.find(order => order?._id === orderId)
        if(!data) {
            setOrderData(propOrder);
        } else {
            setOrderData(data);
        }
    },[orderId, orders, propOrder])

    useEffect(() => {
        const fetchRestaurantPlace = async () => {
            try {
                const value = await AsyncStorage.getItem('restaurantPlace');
                if (value !== null) {
                    const parsedValue = JSON.parse(value);
                    setRestaurantPlace(parsedValue);
                }
            } catch (error) {
                console.error('Error fetching restaurant place:', error);
            }
        };

        fetchRestaurantPlace();
    }, []);

    const translateStatus = (status) => {
        const statusTranslations = {
            accepted: t('accepted'),
            preparing: t('preparing'),
            cancelled: t('cancelled'),
            closed: t('closed'),
            busy: t('busy'),
            ready: t('ready'),
            storno: t('storno')
        };
        return statusTranslations[status] || status;
    };


// Update the mockCreateWoltPromise function
//     const mockCreateWoltPromise = () => {
//         const mockResponse = {
//             data: {
//                 id: "67d0559c12edb3f37805816e",
//                 created_at: "2025-03-11T15:24:12.451613+00:00",
//                 dropoff: {location: { formatted_address: "Bécsi út 89-91., 1034, Budapest" },
//                     options: { scheduled_time: "2025-03-11T16:02:46.711000+00:00" }},
//                 eta_minutes: 30,
//                 location: {
//                     coordinates: {
//                         lat: 47.5326294,
//                         lon: 19.0367819
//                     },
//                     formatted_address: "Bécsi út 89-91., 1034, Budapest"
//                 },
//                 options: {
//                     scheduled_time: null
//                 },
//                 is_binding: true,
//                 parcels: null,
//                 pickup: {
//                     venue_id: "66d07308435bc0dd81f43171",
//                     eta_minutes: 30,
//                     location: {
//                         coordinates: {
//                             lat: 47.5326294,
//                             lon: 19.0367819
//                         },
//                         formatted_address: "Bécsi út 89-91, 1034, Budapest"
//                     },
//                     options: {
//                         min_preparation_time_minutes: 30
//                     }
//                 },
//                 price: {
//                     amount: 215000,
//                     currency: "HUF"
//                 },
//                 time_estimate_minutes: 30,
//                 valid_until: "2025-03-11T16:24:12.451613+00:00",
//                 status: "ShipmentPromise created successfully"
//             }
//         };
//
//         setDeliveryData(mockResponse.data);
//         setDeliveryModalVisible(true);
//     };

    const createWoltDelivery = async (data) => {
        console.log("createWoltDelivery -data: ",data)
        try {
            const token = await getAccessToken();
            const response = await axios.post(ApiConfig.apiURL + '/api/delivery/wolt/delivery', {
                pickup: {
                    options: {
                        min_preparation_time_minutes: data.pickup?.options?.min_preparation_time_minutes
                    },
                    comment: data.pickup?.comment || "",
                    display_name: props.restaurant?.name
                },
                dropoff: {
                    location: {
                        coordinates: {
                            lat: orderData?.addressInfo?.coordinates_raw?.lat || orderData?.addressInfo?.coordinates[0],
                            lon: orderData?.addressInfo?.coordinates_raw?.lng || orderData?.addressInfo?.coordinates[1],
                        }
                    },
                    comment: (orderData?.addressInfo?.deliveryInstructions+", " || "") + (data.dropoff?.comment + ", " || "") + "" + (data.addressInfo?.other+", " || "") + "" + (data.userInfo?.other+", " || "") || "",
                    options: {
                        is_no_contact: false,
                        scheduled_time: data.dropoff?.options?.scheduled_time
                    }
                },
                price: {
                    amount: data.price?.amount,
                    currency: data.price?.currency
                },
                recipient: {
                    name: `${orderData.userInfo?.name?.first} ${orderData.userInfo?.name?.last}`,
                    phone_number: orderData.userInfo?.phone || orderData?.userInfo?.mobilePhone || orderData?.userInfo?.phoneNumber || orderData?.userInfo?.phone_number,
                    email: orderData.userInfo?.email || "",
                },
                parcels: orderData.items.map(item => ({
                    count: item.amount,
                    dimensions: {
                        weight_gram: 0,
                        width_cm: 0,
                        height_cm: 0,
                        depth_cm: 0
                    },
                    price: {
                        amount: item.price * 100 || item.remotePrice * 100,
                        currency: "HUF"
                    },
                    description: item.name,
                    identifier: item._id,
                    dropoff_restrictions: {
                        id_check_required: false
                    },
                    tags: []
                })),
                shipment_promise_id: data.id,
                customer_support: {
                    url: `${restaurantPlace?.contact?.website}`,
                    email: `${restaurantPlace?.contact?.email}`,
                    phone_number: `${restaurantPlace?.contact?.phone}`,
                },
                merchant_order_reference_id: orderData._id,
                sms_notifications: {
                    received: "A Maharaja étterembe rendelésed megérkezett, azonnal nekilátunk. Itt tudod követni: TRACKING_LINK",
                    picked_up: "A Maharaja étteremből rendelésedet felvette egy futár és feléd tart. Itt tudod követni: TRACKING_LINK"
                },
                tips: [],
                ...(orderData.paymentType === "cash" && {
                    cash: {
                        "amount_to_collect": orderData.orderSum * 100,
                        "amount_to_expect": orderData.orderSum * 100
                    }
                }),
                order_number: orderData.orderCode,
                handshake_delivery: {
                    is_required: false
                }
            }, {
                headers: {
                    "Accept-Language": "hu_HU",
                    "authorization": `Bearer ${token}`,
                    "restaurantplaceid": `${restaurantPlace._id}`
                },
            });
            setDeliveryModalVisible(false);
            setIsDialogVisible({
                visible: true,
                type: "success",
                message: t('delivery_created_successfully'),
                onConfirm: () => setIsDialogVisible({ visible: false }),
            });
        } catch (error) {
            console.error('Error creating delivery:', error);
            setIsDialogVisible({
                visible: true,
                type: "error",
                message: t('delivery_creation_failed'),
                onConfirm: () => setIsDialogVisible({ visible: false }),
            });
        }
    };
    const createWoltPromise = async () => {
        try {
            const currentTime = new Date();
            const dropoffTime = new Date(currentTime.getTime() + (props?.acceptMinutes || 40) * 60000);
            const formattedDropoffTime = dropoffTime.toISOString();

            const promise = {
                city: orderData?.addressInfo?.city,
                street: orderData.addressInfo?.address || `${orderData?.addressInfo?.street} ${orderData?.addressInfo?.number || ''}`,
                post_code: orderData?.addressInfo?.zip,
                lat: orderData?.addressInfo?.coordinates_raw?.lat || orderData?.addressInfo?.coordinates[0],
                lon: orderData?.addressInfo?.coordinates_raw?.lng || orderData?.addressInfo?.coordinates[1],
                language: "hu",
                min_preparation_time_minutes: 0,
                scheduled_dropoff_time: formattedDropoffTime
            };
            const token = await getAccessToken();
            const response = await axios.post(ApiConfig.apiURL + '/api/delivery/wolt/shipment-promise', promise, {
                headers: {
                    "Accept-Language": "hu_HU",
                    "authorization": `Bearer ${token}`,
                    "restaurantplaceid": `${restaurantPlace._id}`
                },
            });
            const data = response.data;
            console.log("response.data(setDeliveryData)", data)
            const dropoffTimeString = new Date(data?.dropoff?.options?.scheduled_time).toLocaleTimeString();

            setDeliveryData(data);
            setDeliveryModalVisible(true);
        } catch (error) {
            console.error(error);
            console.log("error_01")
            setIsDialogVisible({
                visible: true,
                type: "error",
                message: t('delivery_creation_failed'),
                onConfirm: () => setIsDialogVisible({ visible: false }),
                onCancel: () => setIsDialogVisible({ visible: false }),
            });
        }
    };

    const handleAccept = async (time) => {
        const token = await getAccessToken();
        const response = await fetch(`https://api.happygastro.hu/api/order/${orderData._id}/status/preparing?orderMinutes=${time}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}` // Replace with your actual token
            }
        });
        setAcceptModalVisible(false);
        RawBTPrintKitchen(orderData, orderData.items);
        console.log(orderData)
        Observables.call("reloadOrders")
    };

    function isAllItemPaired(orderData) {
        // return orderData.items.every(item => item.item && !(Array.isArray(item.item) && item?.item?.length === 0) && !(typeof item.item === 'object' && Object.keys(item.item)?.length === 0));
        return orderData.items.every(item => item.item); //all paired food?
    }

    const handleReject = async (reason) => {
        const token = await getAccessToken();
        await fetch(`${ApiConfig.apiURL}/order/${orderData._id}/status/cancelled?rejectReason=${reason}&storno=true`, {
            method: 'GET',
            headers: {
                'Accept-Language': 'hu_HU',
                'Authorization': `Bearer ${token}`,
            },
        });
        setIsRejectModal(false);
    };

    const handleOrderClose = async () => {
        const token = await getAccessToken();
        await axios.get(ApiConfig.apiURL + `/api/order/${orderData._id}/status/closed`,  {
            headers: {
                "Accept-Language": "hu_HU",
                "authorization": `Bearer ${token}`,
            },
        });
        Observables.call("reloadOrders");
        if (Platform.OS === 'web') {
            alert(t('invoice_closed'));
        } else {
            Alert.alert(t('invoice_closed'));
        }
    };

    const handleStorno = async () => {
        const token = await getAccessToken();
        await axios.post(ApiConfig.apiURL + `/api/order/${orderData._id}/update`, {
            storno: true,
        }, {
            headers: {
                "Accept-Language": "hu_HU",
                "authorization": `Bearer ${token}`,
            },
        });
        Observables.call("reloadOrders");

        if (Platform.OS === 'web') {
            alert(t('invoice_stornoed'));
        } else {
            Alert.alert(t('invoice_stornoed'));
        }
    };

    const handleRedButtonPress = () => {
        if (Platform.OS === 'web') {
            if (window.confirm(t('confirm_storno'))) {
                handleStorno();
            }
        } else {
            Alert.alert(
                t('confirm_storno_title'),
                t('confirm_storno'),
                [
                    {
                        text: t('no'),
                        style: "cancel"
                    },
                    {
                        text: t('yes'),
                        onPress: () => handleStorno()
                    }
                ]
            );
        }
    };

    const renderBuyerInfo = () => (
        <View style={[{ flexGrow: 1, backgroundColor: '#ffffff', padding: 16, borderRadius: 5 }]}>
            <Text style={[styles.sectionTitleCode, { paddingTop: "5px",  }]}>#{orderData.orderCode}</Text>
            <View style={{ flexDirection: 'row', alignItems: 'center', marginBottom: 5 }}>
                <MaterialIcons name="person" size={22} color="#555" />
                <Text style={[styles.sectionTitle, { paddingTop: "10px", marginLeft: 5 }]}>{t('buyer_info')}</Text>
            </View>
            {orderData?.userInfo && (
                <View style={styles.row}>
                    <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                        <MaterialIcons name="account-circle" size={20} color="#555" />
                        <Text style={[styles.label, { marginLeft: 5 }]}>{t('buyer')}:</Text>
                    </View>
                    <Text style={styles.value}>
                        {orderData?.userInfo?.name?.last || ""} {orderData?.userInfo?.name?.first || ""}
                    </Text>
                </View>
            )}
            {orderData?.userInfo?.phone && (
                <View style={styles.row}>
                    <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                        <MaterialIcons name="phone" size={20} color="#555" />
                        <Text style={[styles.label, { marginLeft: 5 }]}>{t('phone_number')}:</Text>
                    </View>
                    <Text style={styles.value}>
                        {orderData?.userInfo?.phone || ""}
                    </Text>
                </View>
            )}
            {(orderData?.userInfo?.mobilePhone) && (
                <View style={styles.row}>
                    <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                        <MaterialIcons name="smartphone" size={20} color="#555" />
                        <Text style={[styles.label, { marginLeft: 5 }]}>{t('phone_number')}:</Text>
                    </View>
                    <Text style={styles.value}>
                        {orderData?.userInfo?.mobilePhone || ""}
                    </Text>
                </View>
            )}
            {orderData?.userInfo?.phoneNumber && (
                <View style={styles.row}>
                    <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                        <MaterialIcons name="phone" size={20} color="#555" />
                        <Text style={[styles.label, { marginLeft: 5 }]}>{t('phone_number')}:</Text>
                    </View>
                    <Text style={styles.value}>
                        {orderData?.userInfo?.phoneNumber || ""}
                    </Text>
                </View>
            )}
            {orderData?.addressInfo && (
                <View style={styles.row}>
                    <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                        <MaterialIcons name="location-on" size={20} color="#555" />
                        <Text style={[styles.label, { marginLeft: 5 }]}>{t('buyer_address')}:</Text>
                    </View>
                    <Text style={styles.value}>
                        {`${orderData?.addressInfo?.zip || ""} ${orderData?.addressInfo?.city || ""}, ${orderData.addressInfo?.address || ""}`}
                    </Text>
                </View>
            )}
        </View>
    );

    const renderPayments = () => (
        <View style={[styles.detailsContainer, { height: "100%" }]}>
            <View style={{ flexDirection: 'row', alignItems: 'center', marginBottom: 5 }}>
                <MaterialIcons name="payment" size={22} color="#555" />
                <Text style={[styles.sectionTitle, { marginLeft: 5 }]}>{t('transactions')}</Text>
            </View>
            <View style={[styles.row, { borderBottomWidth: 1, borderBottomColor: '#ccc' }]}>
                <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                    {getPaymentTypeIcon(orderData?.paymentType)}
                    <Text style={[styles.label, { marginLeft: 5 }]}>{t('payment_type')}:</Text>
                </View>
                <Text style={styles.value}>{paymentType(orderData?.paymentType, t)}</Text>
            </View>
            {orderData?.paymentTypes?.length > 0 && (
                orderData?.paymentTypes.map((p, index) => (
                    <View key={`payment-${index}`} style={styles.row}>
                        <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                            {getPaymentTypeIcon(p.paymentType)}
                            <Text style={[styles.label, { marginLeft: 5 }]}>{paymentType(p.paymentType, t)}</Text>
                        </View>
                        <Text style={styles.value}>{priceFormatter(p.amount)}</Text>
                    </View>
                ))
            )}
            {orderData?.tipAmount > 0 && (
                <View style={styles.row}>
                    <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                        <MaterialIcons name="attach-money" size={20} color="#4CAF50" />
                        <Text style={[styles.label, { marginLeft: 5 }]}>{t('tip')}:</Text>
                    </View>
                    <Text style={styles.value}>{priceFormatter(orderData?.tipAmount)}</Text>
                </View>
            )}
            {orderData?.serviceFee > 0 && (
                <View style={styles.row}>
                    <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                        <MaterialIcons name="miscellaneous-services" size={20} color="#555" />
                        <Text style={[styles.label, { marginLeft: 5 }]}>{t('service_fee')}:</Text>
                    </View>
                    <Text style={styles.value}>{priceFormatter(orderData?.serviceFee)}</Text>
                </View>
            )}
        </View>
    );

    const renderOrderDetails = () => (
        <View style={[styles.detailsContainer]}>

            <View style={styles.row}>
                <Text style={styles.sectionTitle}>{t('details')}</Text>
                {getOrderIcon(orderData?.orderFrom)}
            </View>
            <View style={styles.row}>
                <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                    {getOrderTypeIcon(orderData?.orderType)}
                    <Text style={[styles.label, { marginLeft: 5 }]}>{t('type')}:</Text>
                </View>
                <Text style={styles.value}>{orderType(orderData?.orderType, t)}</Text>
            </View>
            <View style={styles.row}>
                <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                    {getStatusIcon(orderData?.status)}
                    <Text style={[styles.label, { marginLeft: 5 }]}>{t('status')}:</Text>
                </View>
                <Text style={styles.valuePaid}>{translateStatus(orderData?.status)}</Text>
            </View>
            <View style={styles.row}>
                <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                    <MaterialIcons name="store" size={20} color="#555" />
                    <Text style={[styles.label, { marginLeft: 5 }]}>{t('platform')}:</Text>
                </View>
                <Text style={styles.value}>{orderData?.origin || "--"}</Text>
            </View>
            <View style={styles.row}>
                <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                    <MaterialIcons name="access-time" size={20} color="#555" />
                    <Text style={[styles.label, { marginLeft: 5 }]}>{t('created_at')}:</Text>
                </View>
                <Text style={styles.value}>{new Date(orderData?.createdAt).toLocaleString()}</Text>
            </View>
            {orderData?.paymentTypes?.length > 1 ? (
                <View>
                    <View style={[styles.row]}>
                        <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                            <MaterialIcons name="payments" size={20} color="#555" />
                            <Text style={[styles.label, { marginLeft: 5 }]}>{t('paid')}:</Text>
                        </View>
                    </View>
                    {orderData?.paymentTypes.map((p, index) => (
                        <View key={`payment-${index}`} style={styles.row}>
                            <View style={{ flexDirection: 'row', alignItems: 'center', marginLeft: 25 }}>
                                {getPaymentTypeIcon(p.paymentType)}
                            </View>
                            <Text style={styles.value}>{paymentType(p.paymentType, t)} {priceFormatter(p.amount)}</Text>
                        </View>
                    ))}
                </View>
            ) : (
                <View style={[styles.row]}>
                    <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                        {getPaymentTypeIcon(orderData?.paymentType)}
                        <Text style={[styles.label, { marginLeft: 5 }]}>{t('payment_type')}:</Text>
                    </View>
                    <Text style={styles.value}>{paymentType(orderData?.paymentType, t)}</Text>
                </View>
            )}

            {orderData?.tipAmount > 0 && (
                <View style={styles.row}>
                    <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                        <MaterialIcons name="attach-money" size={20} color="#4CAF50" />
                        <Text style={[styles.label, { marginLeft: 5 }]}>{t('tip')}:</Text>
                    </View>
                    <Text style={styles.value}>{priceFormatter(orderData?.tipAmount)}</Text>
                </View>
            )}
            {orderData?.serviceFee > 0 && (
                <View style={styles.row}>
                    <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                        <MaterialIcons name="miscellaneous-services" size={20} color="#555" />
                        <Text style={[styles.label, { marginLeft: 5 }]}>{t('service_fee')} ({orderData?.serviceFee}%):</Text>
                    </View>
                    <Text style={styles.value}>{priceFormatter(orderData?.serviceFeePrice)}</Text>
                </View>
            )}
            {orderData?.deliveryFee > 0 && (
                <View style={styles.row}>
                    <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                        <MaterialIcons name="delivery-dining" size={20} color="#555" />
                        <Text style={[styles.label, { marginLeft: 5 }]}>{t('delivery_fee')}:</Text>
                    </View>
                    <Text style={styles.value}>{priceFormatter(orderData?.deliveryFee)}</Text>
                </View>
            )}
            {orderData?.discountAmount > 0 && (
                <View style={styles.row}>
                    <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                        <MaterialIcons name="local-offer" size={20} color="#F44336" />
                        <Text style={[styles.label, { marginLeft: 5 }]}>{t('discount')}:</Text>
                    </View>
                    <Text style={styles.value}>{priceFormatter(orderData?.discountAmount)}</Text>
                </View>
            )}
            {orderData?.discountPrice > 0 && (
                <View style={styles.row}>
                    <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                        <MaterialIcons name="local-offer" size={20} color="#F44336" />
                        <Text style={[styles.label, { marginLeft: 5 }]}>{t('discount')}:</Text>
                    </View>
                    <Text style={styles.value}>{priceFormatter(orderData?.discountPrice)}</Text>
                </View>
            )}
        </View>
    );

    return (
        <LinearGradient
            colors={['#EAE5EE', '#FEE6DE', '#EBE5F2']}
            style={{ width: '100%', height: '95svh' }}
        >
            {orderData && (
                <View style={[styles.container, { maxHeight: Dimensions.get("screen").height - 70, height: Dimensions.get("screen").height - 70 }]}>
                    <ScrollView ref={scrollViewRef} contentContainerStyle={[styles.scrollView, { paddingBottom: 70 }]}>
                        {orderData?.status === "closed" && <View style={styles.header}>
                            <Text style={styles.headerText}>{t('invoice_closed_message')}</Text>
                        </View>}
                        {(orderData?.status === "cancelled" || orderData?.storno) && <View style={[styles.header, { backgroundColor: 'darkred' }]}>
                            <Text style={styles.headerText}>{t('invoice_cancelled_message')}</Text>
                        </View>}
                        {(orderData?.preOrder) && <View style={[styles.header, { backgroundColor: 'orange' }]}>
                            <Text style={styles.headerText}>{t('pre_order_message')}: {new Date(orderData?.preOrder).toLocaleString()}</Text>
                        </View>}
                        {isTrackingShown &&
                            <View style={{marginBottom: 15}}>
                                {Platform.OS === 'web' ? (
                                    <View style={{ height: "600px" }}>
                                        <iframe
                                            src={orderData?.woltDeliveryResponse?.tracking?.url}
                                            style={{ width: "100%", height: "600px", border: "none" }}
                                            title="Wolt Delivery Tracking"
                                        />
                                    </View>
                                ) : (
                                    <WebView
                                        source={{ uri: `${orderData?.woltDeliveryResponse?.tracking?.url}`}}
                                        style={{ width: '100%', height: 600 }}
                                    />
                                )}
                            </View>
                        }
                        <View style={styles.topSection}>
                            {orderData?.userInfo && <View style={[styles.leftContainer, { flex: 2, alignSelf: 'stretch' }]}>{renderBuyerInfo()}</View>}
                            <View style={[styles.rightContainer, { flex: 2 }]}>{renderOrderDetails()}</View>
                        </View>

                        <View style={styles.middleSection}>
                            <View style={styles.rightHalf}>
                                {orderData?.VIPCard && <View style={styles.detailsContainer}>
                                    <Text style={styles.sectionTitle}>{t('vip_card')}</Text>
                                    <View style={styles.row}>
                                        <Text style={styles.label}>{t('card_id')}:</Text>
                                        <Text style={styles.value}>{orderData?.VIPCard.cardId}</Text>
                                    </View>
                                    <View style={styles.row}>
                                        <Text style={styles.label}>{t('balance')}:</Text>
                                        <Text style={styles.value}>{orderData?.VIPCard.balance}</Text>
                                    </View>
                                    {orderData?.VIPCard?.discountAmount > 0 &&
                                    <View style={styles.row}>
                                        <Text style={styles.label}>{t('discount')}:</Text>
                                        <Text style={styles.value}>{orderData?.VIPCard.discountAmount}%</Text>
                                    </View>}
                                </View>}
                            </View>
                        </View>

                        {/* Invoice Alert */}
                        {orderData && (
                            <>
                                {(() => {
                                    // Check if invoice data exists from either source
                                    const hasVatInvoice = orderData?.userInfo?.vatInvoice;
                                    const needsInvoice = orderData.needInvoice && orderData.invoiceData;

                                    // Get the invoice data from the appropriate source
                                    let invoiceData = null;
                                    if (hasVatInvoice) {
                                        invoiceData = orderData.userInfo.vatInvoice;
                                    } else if (needsInvoice) {
                                        invoiceData = orderData.invoiceData;
                                    }



                                    return (hasVatInvoice || needsInvoice) ? (
                                        <View style={{
                                            backgroundColor: '#fff3cd',
                                            borderColor: '#ffeeba',
                                            borderWidth: 1,
                                            borderRadius: 5,
                                            padding: 10,
                                            marginHorizontal: 10,
                                            marginBottom: 10
                                        }}>
                                            <View style={{ flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', marginBottom: showInvoiceDetails ? 10 : 0 }}>
                                                <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                                                    <MaterialIcons name="receipt" size={20} color="#856404" style={{ marginRight: 5 }} />
                                                    <Text style={{ color: '#856404', fontSize: 14, fontWeight: 'bold' }}>
                                                        {t('need_invoice')}
                                                    </Text>
                                                </View>
                                                <View style={{ flexDirection: 'row' }}>
                                                    <TouchableOpacity 
                                                        style={{ 
                                                            backgroundColor: '#007bff', 
                                                            paddingHorizontal: 10, 
                                                            paddingVertical: 5, 
                                                            borderRadius: 5,
                                                            marginRight: 10
                                                        }}
                                                        onPress={() => setShowInvoiceDetails(!showInvoiceDetails)}
                                                    >
                                                        <Text style={{ color: 'white', fontSize: 12 }}>
                                                            {showInvoiceDetails ? t('hide_invoice_data') : t('show_invoice_data')}
                                                        </Text>
                                                    </TouchableOpacity>
                                                    <TouchableOpacity 
                                                        style={{ 
                                                            backgroundColor: '#6c757d', 
                                                            paddingHorizontal: 10, 
                                                            paddingVertical: 5, 
                                                            borderRadius: 5,
                                                            opacity: 0.6
                                                        }}
                                                        disabled={true}
                                                    >
                                                        <Text style={{ color: 'white', fontSize: 12 }}>
                                                            {t('send_online_invoice')}
                                                        </Text>
                                                    </TouchableOpacity>
                                                </View>
                                            </View>

                                            {showInvoiceDetails && invoiceData && (
                                                <View style={{ marginTop: 10, paddingTop: 10, borderTopWidth: 1, borderTopColor: '#ffeeba' }}>
                                                    {hasVatInvoice ? (
                                                        <>
                                                            <Text style={{ color: '#856404', fontSize: 14, marginBottom: 5 }}>
                                                                <Text style={{ fontWeight: 'bold' }}>{t('company_name')}: </Text>
                                                                {invoiceData.billingCompanyName}
                                                            </Text>
                                                            <Text style={{ color: '#856404', fontSize: 14, marginBottom: 5 }}>
                                                                <Text style={{ fontWeight: 'bold' }}>{t('tax_number')}: </Text>
                                                                {invoiceData.taxNumber}
                                                            </Text>
                                                            <Text style={{ color: '#856404', fontSize: 14, marginBottom: 5 }}>
                                                                <Text style={{ fontWeight: 'bold' }}>{t('billing_address')}: </Text>
                                                                {`${invoiceData.billingAddress.zip} ${invoiceData.billingAddress.city}, ${invoiceData.billingAddress.address} ${invoiceData.billingAddress.other || ''}`}
                                                            </Text>
                                                        </>
                                                    ) : (
                                                        <>
                                                            {invoiceData.company && (
                                                                <>
                                                                    <Text style={{ color: '#856404', fontSize: 14, marginBottom: 5 }}>
                                                                        <Text style={{ fontWeight: 'bold' }}>{t('company_name')}: </Text>
                                                                        {invoiceData.company.nev}
                                                                    </Text>
                                                                    <Text style={{ color: '#856404', fontSize: 14, marginBottom: 5 }}>
                                                                        <Text style={{ fontWeight: 'bold' }}>{t('tax_number')}: </Text>
                                                                        {invoiceData.company.adoszam}
                                                                    </Text>
                                                                    <Text style={{ color: '#856404', fontSize: 14, marginBottom: 5 }}>
                                                                        <Text style={{ fontWeight: 'bold' }}>{t('address')}: </Text>
                                                                        {invoiceData.company.cim}
                                                                    </Text>
                                                                </>
                                                            )}
                                                            {invoiceData.invoiceNumber && (
                                                                <Text style={{ color: '#856404', fontSize: 14, marginBottom: 5 }}>
                                                                    <Text style={{ fontWeight: 'bold' }}>{t('invoice_number')}: </Text>
                                                                    {invoiceData.invoiceNumber}
                                                                </Text>
                                                            )}
                                                            {(invoiceData.firstName || invoiceData.lastName) && (
                                                                <Text style={{ color: '#856404', fontSize: 14, marginBottom: 5 }}>
                                                                    <Text style={{ fontWeight: 'bold' }}>{t('name')}: </Text>
                                                                    {`${invoiceData.lastName || ''} ${invoiceData.firstName || ''}`}
                                                                </Text>
                                                            )}
                                                        </>
                                                    )}
                                                </View>
                                            )}
                                        </View>
                                    ) : null;
                                })()}
                            </>
                        )}

                        {/* Order Comment Alert */}
                        {orderData && (
                            <>
                                {(() => {
                                    let orderComment = "";
                                    if (orderData.addressInfo) {
                                        if (orderData.addressInfo.deliveryInstructions) {
                                            orderComment = orderComment + (orderComment ? ", " : "") + orderData.addressInfo.deliveryInstructions;
                                        }
                                        if (orderData.addressInfo.other && orderData.addressInfo.other.info) {
                                            orderComment = orderComment + (orderComment ? ", " : "") + orderData.addressInfo.other.info;
                                        }
                                        if (orderData.addressInfo.other && orderData.addressInfo.other.doorBell) {
                                            orderComment = orderComment + (orderComment ? ", " : "") + orderData.addressInfo.other.doorBell;
                                        }
                                    }
                                    if (orderData.comment) {
                                        orderComment = orderComment + (orderComment ? ", " : "") + orderData.comment;
                                    }

                                    return orderComment ? (
                                        <View style={{
                                            backgroundColor: '#d1ecf1',
                                            borderColor: '#bee5eb',
                                            borderWidth: 1,
                                            borderRadius: 5,
                                            padding: 10,
                                            marginHorizontal: 10,
                                            marginBottom: 10
                                        }}>
                                            <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                                                <MaterialIcons name="comment" size={20} color="#0c5460" style={{ marginRight: 5 }} />
                                                <Text style={{ color: '#0c5460', fontSize: 14 }}>
                                                    <Text style={{ fontWeight: 'bold' }}>{t('order_comment')}: </Text>
                                                    {orderComment}
                                                </Text>
                                            </View>
                                        </View>
                                    ) : null;
                                })()}
                            </>
                        )}

                        <View style={styles.itemsContainer}>
                            {showPairingAlert && (
                                <Animated.View style={{ backgroundColor: fadeAnim.interpolate({
                                        inputRange: [0, 1],
                                        outputRange: ['transparent', 'red']
                                    }), padding: 10, borderRadius: 5 }}>
                                    <Text style={{ color: fadeAnim.interpolate({
                                            inputRange: [0, 1],
                                            outputRange: ['red', 'white']
                                        }), fontSize: 22, fontWeight: "bold", textAlign: "center" }}>
                                        {t("every_item_needs_to_be_paired")}
                                    </Text>
                                </Animated.View>
                            )}
                            <Text style={styles.itemHeader}>{t('order_items')}</Text>
                            {orderData?.items?.map((item, index) => (
                                <View key={`item-${index}`}>
                                    {/* Main Item Row */}
                                    {(orderData?.orderFrom === "netpincer" || orderData?.orderFrom === "wolt" || orderData?.orderFrom === "webshop") ? (
                                        <View style={styles.itemRow}>
                                            {/* Left Side: Price + Amount x Name */}
                                            <Text style={styles.itemPrice}>{priceFormatter(item.remotePrice)}</Text>
                                            <View style={{ flex: 1 }}>
                                                <Text style={styles.itemName}>{`${item.amount} x ${item.remoteName || item.name}`}</Text>
                                                {(item.comment || (item.comments && item.comments.length > 0) || item.serveType) && (
                                                    <Text style={[styles.itemName, { fontSize: 12, fontStyle: 'italic', color: '#666' }]}>
                                                        {item.comment || (item.comments && item.comments.join(", ")) || item.serveType}
                                                    </Text>
                                                )}
                                            </View>

                                            {/* Pairing Button */}
                                            <TouchableOpacity
                                                style={[
                                                    styles.pairingButton,
                                                    { backgroundColor: item.item ? "#cbefc5" : "#d3a0a0" }
                                                ]}
                                                onPress={() => openPairingModal(item)}
                                            >
                                                <Text style={{ color: item.item ? "black" : "white", fontWeight: "bold" }}>
                                                    {item.item?.name?.hu || item.item?.name?.en || t("not_paired")}
                                                </Text>
                                            </TouchableOpacity>

                                            {/* Right Side: Final Price */}
                                            <Text style={styles.itemPriceRight}>{priceFormatter(item.amount * item.price)}</Text>
                                        </View>
                                    ) : (
                                        <TouchableOpacity style={styles.itemRow} onPress={() => console.log("item pressed.")}>
                                            <View style={{ flex: 1 }}>
                                                <Text style={[styles.itemName, { fontWeight: 'bold' }]}>{item.remoteName || item.name}</Text>
                                                {(item.comment || (item.comments && item.comments.length > 0) || item.serveType) && (
                                                    <Text style={[styles.itemName, { fontSize: 12, fontStyle: 'italic', color: '#666' }]}>
                                                        {item.comment || (item.comments && item.comments.join(", ")) || item.serveType}
                                                    </Text>
                                                )}
                                            </View>
                                            <Text style={[styles.itemQuantity, { fontWeight: 'bold' }]}>{item.amount} {t('pcs')}</Text>
                                            <Text style={[styles.itemPrice, styles.itemPriceRight, { fontWeight: 'bold' }]}>{priceFormatter(item.amount * (item.remotePrice || item.price))}</Text>
                                        </TouchableOpacity>
                                    )}

                                    {/* Render Extras Directly Under Each Item */}
                                    {item.extras?.length > 0 && item.extras.map((extra, extraIndex) => {
                                       if(orderData?.orderFrom === "netpincer" || orderData?.orderFrom === "wolt" || orderData?.orderFrom === "webshop"){
                                           return (
                                               <View key={`extra-${index}-${extraIndex}`} style={[styles.itemRow]}>

                                                   {/* Left Side: Price + Amount x Extra Name */}
                                                   <Text
                                                       style={styles.itemPrice}>{priceFormatter(extra.remotePrice || extra.price)}</Text>
                                                   <Text
                                                       style={styles.itemName}>{`${item.amount} x ${extra.remoteName || extra.item?.name?.hu || extra.item?.name?.en || 'Extra'}`}</Text>

                                                   {/* Pairing Button for Extras */}
                                                   <TouchableOpacity
                                                       style={[
                                                           styles.pairingButton,
                                                           {backgroundColor: extra.item ? "#cbefc5" : "#d3a0a0"}
                                                       ]}
                                                       onPress={() => openPairingModal(extra)}
                                                   >
                                                       <Text style={{
                                                           color: extra.item ? "black" : "white",
                                                           fontWeight: "bold"
                                                       }}>
                                                           {extra.item?.name?.hu || extra.item?.name?.en || t('not_paired')}
                                                       </Text>
                                                   </TouchableOpacity>

                                                   {/* Right Side: Final Price */}
                                                   <Text
                                                       style={styles.itemPriceRight}>{priceFormatter(item.amount * (extra.price || 0))}</Text>

                                               </View>
                                           )
                                       }else{
                                           return(
                                           <TouchableOpacity style={styles.extraItemRow} onPress={() => console.log(extra)}>
                                               <Text style={[styles.itemName, { fontWeight: 'bold' , color: "#575757"}]}>{extra.item?.remoteName || extra.item?.name?.hu}</Text>
                                               <Text style={[styles.itemQuantity, { fontWeight: 'bold', color: "#575757" }]}>{item.amount} {t('pcs')}</Text>
                                               <Text style={[styles.itemPrice, { fontWeight: 'bold', color: "#575757" }]}>{priceFormatter(item.amount * (extra.price || 0))}</Text>
                                           </TouchableOpacity>)

                                       }

                                    })}
                                </View>
                            ))}

                            <View style={[styles.totalRow, { borderTopWidth: 0.6, borderTopColor: '#b0b0b0', marginVertical: 8 }]}>
                                <Text style={styles.totalText}>{t('products_total')}</Text>
                                <Text style={styles.totalValue}>{priceFormatter(orderData?.productsPrice)}</Text>
                            </View>

                            {/* VAT Breakdown Table */}
                            {orderData?.items && orderData.items.length > 0 && (
                                <View style={{ marginTop: 10, marginBottom: 10 }}>
                                    <Text style={[styles.itemHeader, { marginBottom: 5 }]}>{t('vat_breakdown')}</Text>
                                    <View style={{ borderWidth: 1, borderColor: '#ddd', borderRadius: 5 }}>
                                        {/* Table Header */}
                                        <View style={{ flexDirection: 'row', backgroundColor: '#f5f5f5', padding: 8, borderBottomWidth: 1, borderBottomColor: '#ddd' }}>
                                            <Text style={{ flex: 1, fontWeight: 'bold', textAlign: 'center' }}>{t('vat_rate')}</Text>
                                            <Text style={{ flex: 1, fontWeight: 'bold', textAlign: 'center' }}>{t('vat_amount')}</Text>
                                            <Text style={{ flex: 1, fontWeight: 'bold', textAlign: 'center' }}>{t('net_amount')}</Text>
                                            <Text style={{ flex: 1, fontWeight: 'bold', textAlign: 'center' }}>{t('gross_amount')}</Text>
                                        </View>

                                        {/* Table Rows */}
                                        {(() => {
                                            const vatBreakdown = calcVatPercentages(orderData.items, orderData);
                                            const vatRates = Object.keys(vatBreakdown.vat).sort();

                                            return vatRates.map((rate, index) => {
                                                // Skip service fee entries for now
                                                if (rate.startsWith('Sz') || rate.startsWith('Szervízdíj')) {
                                                    return null;
                                                }

                                                return (
                                                    <View key={`vat-row-${index}`} style={{ flexDirection: 'row', padding: 8, borderBottomWidth: index < vatRates.length - 1 ? 1 : 0, borderBottomColor: '#ddd' }}>
                                                        <Text style={{ flex: 1, textAlign: 'center' }}>{rate}%</Text>
                                                        <Text style={{ flex: 1, textAlign: 'center' }}>{priceFormatter(vatBreakdown.vat[rate])}</Text>
                                                        <Text style={{ flex: 1, textAlign: 'center' }}>{priceFormatter(vatBreakdown.net[rate])}</Text>
                                                        <Text style={{ flex: 1, textAlign: 'center' }}>{priceFormatter(vatBreakdown.gross[rate])}</Text>
                                                    </View>
                                                );
                                            });
                                        })()}
                                    </View>
                                </View>
                            )}

                            {orderData?.deliveryFee > 0 && <View style={[styles.totalRow, { borderTopWidth: 0.6, borderTopColor: '#b0b0b0', marginVertical: 8 }]}>
                                <Text style={styles.totalText}>{t('delivery_fee')}</Text>
                                <Text style={styles.totalValue}>{priceFormatter(orderData?.deliveryFee)}</Text>
                            </View>}

                            {orderData?.serviceFeePrice > 0 && <View style={[styles.totalRow, { borderTopWidth: 0.6, borderTopColor: '#b0b0b0', marginVertical: 8 }]}>
                                <Text style={styles.totalText}>{t('service_fee')} ({orderData?.serviceFee}%)</Text>
                                <Text style={styles.totalValue}>{priceFormatter(orderData?.serviceFeePrice)}</Text>
                            </View>}
                            {orderData?.tipAmount > 0 && <View style={[styles.totalRow, { borderTopWidth: 0.6, borderTopColor: '#b0b0b0', marginVertical: 8 }]}>
                                <Text style={styles.totalText}>{t('tip')}</Text>
                                <Text style={styles.totalValue}>{priceFormatter(orderData?.tipAmount)}</Text>
                            </View>}

                            <View style={styles.totalRow}>
                                <Text style={styles.totalText}>{t('paid')}:</Text>
                                <Text style={styles.totalValue}>{priceFormatter(orderData?.paymentTypes.reduce((a, b) => +a + b.amount, 0))}</Text>
                            </View>
                        </View>


                        <View>
                            {orderData && <Timeline orderData={orderData}/>}
                        </View>


                    </ScrollView>
                    <View style={{ flexDirection: 'column', width: '100%' }}>
                        <View style={[styles.buttonContainer, { alignItems: 'flex-end', flex: 5, width: ((orderData?.status === "accepted" || orderData?.status === "preparing" || !orderData?.storno)) ? "100" : "50%" }]}>

                            {(orderData?.status !== "cancelled" || !orderData?.storno) && orderData?.status !== "pending" && (
                                <TouchableOpacity style={styles.redButton} onPress={handleRedButtonPress}>
                                    <Text style={styles.buttonText}>{t('storno_refund')}</Text>
                                </TouchableOpacity>
                            )}
                            {(orderData?.status !== "closed" || orderData?.status !== "cancelled" || !orderData?.storno) && orderData?.status === "pending" && (
                                <TouchableOpacity style={styles.redButton} onPress={() => setIsRejectModal(true)}>
                                    <Text style={styles.buttonText}>{t('reject')}</Text>
                                </TouchableOpacity>
                            )}
                            {(orderData?.status !== "closed" || orderData.status !== "cancelled" || !orderData.storno) && orderData?.status === "pending" && isAllItemPaired(orderData) && (
                                <TouchableOpacity style={[styles.button, styles.acceptButton]} onPress={() => {handleAcceptButtonPress()}}>
                                    <Text style={styles.buttonText}>{t('accept')}</Text>
                                </TouchableOpacity>
                            )}
                            {((orderData?.status === "accepted" || orderData?.status === "preparing" || orderData?.status === "ready" || orderData?.status === "busy") && !orderData?.storno && orderData.status !== "closed") && (
                                <>
                                    <TouchableOpacity style={styles.orangeButton} onPress={() => setReprintModalVisible(true)}>
                                        <Text style={styles.buttonText}>{t('reprint')}</Text>
                                    </TouchableOpacity>
                                    {orderData?.orderType === "online" && orderData?.addressInfo && (
                                        <TouchableOpacity style={styles.blueButton} onPress={createWoltPromise}>
                                        <Text style={styles.buttonText}>{t('wolt_courier')}</Text>
                                    </TouchableOpacity>)}


                                    <TouchableOpacity style={styles.orangeButton} onPress={handleOrderClose}>
                                        <Text style={styles.buttonText}>{t('close_invoice')}</Text>
                                    </TouchableOpacity>
                                </>
                            )}
                            {orderData?.woltDeliveryResponse?.tracking?.url &&
                                <TouchableOpacity
                                    style={styles.blueButton}
                                    onPress={() => {
                                        setTrackingShown(!isTrackingShown);
                                        if (scrollViewRef.current) {
                                            scrollViewRef.current.scrollTo({ y: 0, animated: true });
                                        }
                                    }}
                                >
                                    <Text style={styles.buttonText}>{isTrackingShown ? t('back_to_details') : t("tracking")}</Text>
                                </TouchableOpacity> }
                        </View>
                    </View>
                    {isReprintModalVisible && (
                        <ReprintModal
                            isVisible={isReprintModalVisible}
                            onClose={() => setReprintModalVisible(false)}
                            orderData={orderData}
                        />
                    )}
                    <HappyDialog.alert
                        visible={isDialogVisible?.visible}
                        type={isDialogVisible?.type || "info"}
                        message={isDialogVisible?.message}
                        confirmText={isDialogVisible?.confirmText}
                        cancelText={isDialogVisible?.cancelText}
                        onConfirm={isDialogVisible?.onConfirm}
                        onCancel={isDialogVisible?.onCancel}
                    />
                    {(isDeliveryModalVisible && deliveryData) && (<DeliveryModal
                        open={isDeliveryModalVisible && deliveryData}
                        onClose={() => setDeliveryModalVisible(false)}
                        onConfirm={() => {
                            // todo: Test createWoltDelivery
                            createWoltDelivery(deliveryData.data)
                            setDeliveryModalVisible(false);
                        }}
                        deliveryData={deliveryData}
                    />)}
                    {orderData.status === "pending" && (
                        <>
                            <OrderAcceptTimePicker
                                isVisible={isAcceptModalVisible}
                                onClose={() => setAcceptModalVisible(false)}
                                onConfirm={handleAccept}
                                orderData={orderData}
                            />
                            <OrderRejectModal
                                isVisible={isRejectModalVisible}
                                onClose={() => setIsRejectModal(false)}
                                onConfirm={handleReject}
                            />
                        </>
                    )}
                    {isPairingModalVisible && (
                        <PairingModal
                            visible={isPairingModalVisible}
                            onClose={closePairingModal}
                            pairingItem={pairingItem}
                            orderId={orderId}
                            order={orderData}
                        />
                    )}
                </View>
            )}
        </LinearGradient>
    );
};

const styles = StyleSheet.create({
    container: {
        height: '95vh',
        paddingBottom: 85
    },
    scrollView: {
        padding: 16,
        paddingBottom: 70, // Add padding to avoid content being hidden behind buttons
        marginBottom: 70, // Add padding to avoid content being hidden behind buttons
        height: '95svh'
    },
    header: {
        backgroundColor: '#d6f5d6',
        padding: 10,
        borderRadius: 5,
        marginBottom: 16,
    },
    topSection: {
        flexDirection: 'row',
        justifyContent: 'space-between',
    },
    headerText: {
        color: '#008000',
        fontSize: 14,
        fontWeight: "700",
        textAlign: 'center',
    },
    pairingButton: {
        flex: 1,
        padding: 6,
        borderRadius: 5,
        alignItems: "center",
        justifyContent: "center",
        marginHorizontal: 8,
    },
    detailsContainer: {
        backgroundColor: '#ffffff',
        padding: 16,
        borderRadius: 5,
        marginBottom: 16,
    },
    row: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        marginBottom: 8,
    },
    label: {
        fontSize: 14,
        color: '#555555',
    },
    value: {
        fontSize: 14,
        color: '#000000',
    },
    valuePaid: {
        fontSize: 14,
        color: '#008000',
        fontWeight: 'bold',
    },
    itemsContainer: {
        backgroundColor: '#ffffff',
        padding: 16,
        borderRadius: 5,
        marginBottom: 16,
    },
    itemHeader: {
        fontSize: 14,
        fontWeight: 'bold',
        marginBottom: 8,
    },
    itemRow: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        marginBottom: 8,
    },
    extraItemRow: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        marginBottom: 8,
        paddingLeft: 10
    },
    itemName: {
        flex: 2,
        fontSize: 14,
        color: '#000000',
    },
    itemQuantity: {
        flex: 1,
        fontSize: 14,
        color: '#000000',
        textAlign: 'center',
    },
    itemPrice: {
        flex: 1,
        fontWeight: "400",
        fontSize: 14,
        color: '#000000',
        textAlign: 'left',
    },
    itemPriceRight: {
        flex: 1,
        fontWeight: "400",
        fontSize: 14,
        color: '#000000',
        textAlign: 'right',
    },
    totalRow: {
        fontWeight: "900",
        flexDirection: 'row',
        justifyContent: 'space-between',
        marginBottom: 4,
    },
    totalText: {
        fontWeight: "900",
        fontSize: 14,
        color: '#555555',
    },
    totalValue: {
        fontWeight: "900",
        fontSize: 14,
        color: '#000000',
    },
    buttonContainer: {
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        flexDirection: 'row',
        padding: 16,
        minHeight: 70,
        backgroundColor: '#f5f5f5',
    },
    greenButton: {
        flex: 1,
        backgroundColor: '#008000',
        padding: 10,
        borderRadius: 5,
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        marginRight: 8,
    },
    orangeButton: {
        flex: 1,
        backgroundColor: '#FFA500',
        padding: 10,
        borderRadius: 5,
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        marginRight: 8,
    },
    redButton: {
        flex: 1,
        backgroundColor: '#FF0000',
        padding: 10,
        borderRadius: 5,
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        marginRight: 8,
    },
    buttonText: {
        color: '#ffffff',
        fontSize: 14,
        fontWeight: 'bold',
        justifyContent: 'center',
        textAlign: 'center',
    },
    button: {
        flex: 1,
        padding: 10,
        borderRadius: 5,
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        marginHorizontal: 5,
    },
    acceptButton: {
        backgroundColor: 'green',
    },
    blueButton: {
        flex: 1,
        backgroundColor: '#36bdfb',
        padding: 10,
        borderRadius: 5,
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        marginRight: 8,
    },
    eventContainer: {
        flexDirection: 'row',
        marginBottom: 24,
    },
    iconLineContainer: {
        alignItems: 'center',
        marginRight: 16,
    },
    sectionTitle: {
        fontSize: 18,
        fontWeight: 'bold',
        marginBottom: 8,
    },
    sectionTitleCode: {
        fontSize: 20,
        fontWeight: 'bold',
        marginBottom: 4,
    },
    leftHalf: {
        flex: 1,
        marginRight: 8,
    },
    rightHalf: {
        flex: 1,
        marginLeft: 8,
    },
    leftContainer: {
        flex: 1,
        marginRight: 8,
        alignSelf: 'stretch',
    },
    rightContainer: {
        flex: 1,
        marginLeft: 8,
    },
    middleSection: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        marginTop: 16,
    },
    line: {
        width: 2,
        height: 40,
        backgroundColor: '#d3d3d3',
        marginTop: 4,
    },
    eventContent: {
        flex: 1,
    },
    description: {
        fontSize: 14,
        color: '#555',
    },
    modalBackgroundReprint: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
    },
    modalContainerReprint: {
        width: '60%',
        backgroundColor: 'white',
        borderRadius: 10,
        padding: 20,
        alignItems: 'center',
    },
    buttonReprint: {
        width: '100%',
        padding: 20,
        backgroundColor: '#007bff',
        borderRadius: 5,
        marginVertical: 10,
        alignItems: 'center',
    },
    buttonTextReprint: {
        color: 'white',
        fontSize: 18,
        fontWeight: 'bold',
    },
    title: {
        fontSize: 24,
        fontWeight: 'bold',
        marginBottom: 20,
        color: '#333',
    },
    timeline: {
        flexDirection: 'column',
        position: 'relative',
        paddingBottom: 75, // Add padding to avoid content being hidden behind buttons
    },
    eventRow: {
        flexDirection: 'row',
        marginBottom: 20,
    },
    iconContainer: {
        alignItems: 'center',
        width: 50,
    },
    icon: {
        width: 12,
        height: 12,
        borderRadius: 6,
        backgroundColor: '#ff8000',
    },
    verticalLine: {
        width: 2,
        height: 50,
        backgroundColor: '#d3d3d3',
        marginTop: 4,
    },
    eventCard: {
        backgroundColor: '#fff',
        padding: 16,
        borderRadius: 10,
        elevation: 2, // Adds shadow for Android
        shadowColor: '#000', // Adds shadow for iOS
        shadowOpacity: 0.1,
        shadowOffset: { width: 0, height: 2 },
        shadowRadius: 4,
        flex: 1,
    },
    date: {
        fontSize: 14,
        color: '#999',
        marginBottom: 8,
    },
    eventTitle: {
        fontSize: 16,
        fontWeight: 'bold',
        color: '#333',
        marginBottom: 4,
    },
    eventDescription: {
        fontSize: 14,
        color: '#666',
    },
    // Confirmation dialog styles
    confirmationModalBackground: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
    },
    confirmationModalContainer: {
        width: '60%',
        backgroundColor: 'white',
        borderRadius: 10,
        padding: 20,
        alignItems: 'center',
    },
    confirmationTitle: {
        fontSize: 20,
        fontWeight: 'bold',
        marginBottom: 15,
        color: '#333',
    },
    confirmationText: {
        fontSize: 16,
        color: '#555',
        marginBottom: 20,
        textAlign: 'center',
    },
    confirmationButtonsContainer: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        width: '100%',
    },
    confirmationButton: {
        padding: 15,
        borderRadius: 5,
        alignItems: 'center',
        justifyContent: 'center',
        width: '48%',
    },
    confirmationButtonText: {
        fontSize: 16,
        fontWeight: 'bold',
    },
});

export default OrderDetailsScreen;
